/**
 * @generated SignedSource<<af0cc766b5eb404f566c35cf2d748878>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useStaticDataQuery$variables = {};
export type useStaticDataQuery$data = {
  readonly genres: ReadonlyArray<{
    readonly genre: string;
    readonly id: string;
  } | null> | null;
};
export type useStaticDataQuery = {
  response: useStaticDataQuery$data;
  variables: useStaticDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GenreNode",
    "kind": "LinkedField",
    "name": "genres",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "genre",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useStaticDataQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useStaticDataQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fa76469464e13bee60c4e4fa9460cf7c",
    "id": null,
    "metadata": {},
    "name": "useStaticDataQuery",
    "operationKind": "query",
    "text": "query useStaticDataQuery {\n  genres {\n    id\n    genre\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d7a7ea98cfba3474cfe596e8c9a8d62";

export default node;
